<div class="mobile-warning-banner" *ngIf="isMobileOrTablet">
  <mat-icon class="warning-icon">warning</mat-icon>
  <span class="warning-text">
    <strong>For the best experience:</strong> We recommend using this portal on
    a desktop/laptop device, as it was specifically built for that use.
  </span>
</div>
<app-toolbar></app-toolbar>

<div class="ropa-container">
  <!-- Breadcrumbs -->
  <nav class="breadcrumbs">
    <a href="/dashboard" class="breadcrumb-link">
      <img src="assets/icons/arrow_back.svg" alt="arrow back" />Dashboard</a
    >
    <span class="breadcrumb-separator">-</span>
    <span class="breadcrumb-current">{{
      uiMode === "editing"
        ? "Edit " + (ropaName || "ROPA-" + ropaId)
        : uiMode === "readonly"
        ? "View " + (ropaName || "ROPA-" + ropaId)
        : "New ROPA"
    }}</span>
  </nav>

  <!-- Page Title -->
  <h1 class="page-title">
    {{
      uiMode === "editing"
        ? "Edit " + (ropaName || "ROPA-" + ropaId)
        : uiMode === "readonly"
        ? "View " + (ropaName || "ROPA-" + ropaId)
        : "New ROPA"
    }}
  </h1>

  <!-- Submission Confirmation Page -->
  <div *ngIf="showSubmissionConfirmation" class="submission-confirmation">
    <div class="confirmation-content">
      <h2 class="confirmation-title">
        The file "{{
          businessProcessName || (isEditMode ? "ROPA-" + ropaId : "New ROPA")
        }}" has been {{ isEditMode ? "updated" : "created" }}
      </h2>

      <p class="confirmation-question" *ngIf="!isEditMode">
        Do you want to publish it or keep it in your Drafts?
      </p>

      <p class="confirmation-question" *ngIf="isEditMode">
        Do you want to publish the changes or keep them in your Drafts?
      </p>

      <div class="submission-options">
        <label class="radio-option">
          <input
            type="radio"
            name="submissionType"
            value="publish"
            [checked]="selectedSubmissionType === 'publish'"
            (change)="onSubmissionTypeChange('publish')"
          />
          <span class="radio-label">Publish File</span>
        </label>
      </div>

      <div class="reminder-section">
        <h3 class="reminder-title">Reminder</h3>
        <ul class="reminder-list">
          <li>
            Anyone can edit the file, but ownership transfers to the most recent
            editor
          </li>
          <li>
            You can access the file at any time and select a specific version
          </li>
          <li>
            You can download all versions of the file that have been created
          </li>
        </ul>
      </div>

      <div class="confirmation-actions">
        <button
          type="button"
          class="btn btn-back"
          (click)="onSubmissionCancel()"
        >
          Cancel
        </button>

        <div class="right-buttons">
          <button
            type="button"
            class="btn btn-back"
            (click)="onSubmissionBack()"
          >
            Back
          </button>

          <button
            type="button"
            class="btn btn-continue"
            (click)="onSubmissionContinue()"
          >
            Continue to Publish
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Steps Navigation (hidden during submission confirmation) -->
  <div class="steps-container" *ngIf="!showSubmissionConfirmation">
    <div class="steps-wrapper">
      <div
        *ngFor="let step of steps"
        class="step-item"
        [class.active]="step.active"
        [class.completed]="step.completed"
        (click)="goToStep(step.number)"
      >
        <div class="step-circle">
          <span class="step-number">{{ step.number }}</span>
        </div>
        <div class="step-title">{{ step.title }}</div>
      </div>
    </div>
  </div>

  <!-- Form Content (hidden during submission confirmation) -->
  <div class="form-container" *ngIf="!showSubmissionConfirmation">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-container">
      <div class="error-message">
        <h3>Error</h3>
        <p>{{ error }}</p>
        <button type="button" class="btn btn-primary" (click)="loadRopaForm()">
          Reintentar
        </button>
      </div>
    </div>

    <!-- Dynamic Step Content -->
    <div
      *ngIf="getCurrentStepData() && !isLoading && !error"
      class="step-content"
    >
      <p *ngIf="currentStep === 1" style="font-size: 13px; margin-bottom: 1.5rem; color: #333">
        <span style="font-weight: bold">Mandatory fields</span> are marked with
        an asterisk (*). Required: Name, SET Area and Name of Business Process Owner.
      </p>
      <!-- <h2 class="step-heading">{{ getCurrentStepData()?.title }}</h2> -->

      <!-- Iterate through questionGroups -->
      <div
        *ngFor="let questionGroup of getCurrentStepData()?.questionGroups"
        class="form-section"
        [ngClass]="{ 'no-title': !questionGroup.title }"
      >
        <h3 *ngIf="questionGroup.title" class="section-title">
          {{ questionGroup.title }}
        </h3>

        <!-- Special handling for the first questionGroup to display fields in a row -->
        <div *ngIf="questionGroup.id === 'subsection_1'" class="form-row">
          <div
            *ngFor="let field of questionGroup.fields"
            class="form-group"
            [ngClass]="'field-' + field.type"
          >
            <ng-container [ngSwitch]="field.type">
              <!-- Text Input -->
              <ng-container *ngSwitchCase="'text'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <div [innerHTML]="field.description"></div>
                </div>
                <input
                  [id]="'field_' + field.id"
                  type="text"
                  class="form-control"
                  [placeholder]="field.placeholder || ''"
                  [value]="getFieldValue(field)"
                  [required]="field.required"
                  [disabled]="isReadOnly"
                  (input)="onFieldChange(field, $any($event.target).value)"
                />
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>
            </ng-container>
          </div>
        </div>

        <!-- Regular field iteration for other questionGroups -->
        <div *ngIf="questionGroup.id !== 'subsection_1'">
          <div
            *ngFor="let field of questionGroup.fields"
            class="form-group"
            [ngClass]="'field-' + field.type"
          >
            <ng-container [ngSwitch]="field.type">
              <!-- Text Input -->
              <ng-container *ngSwitchCase="'text'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <input
                  [id]="'field_' + field.id"
                  type="text"
                  class="form-control"
                  [placeholder]="field.placeholder || ''"
                  [value]="getFieldValue(field)"
                  [required]="field.required"
                  [disabled]="isReadOnly"
                  (input)="onFieldChange(field, $any($event.target).value)"
                />
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Email Input -->
              <ng-container *ngSwitchCase="'email'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <div [innerHTML]="field.description"></div>
                </div>
                <input
                  [id]="'field_' + field.id"
                  type="email"
                  class="form-control"
                  [placeholder]="field.placeholder || ''"
                  [value]="getFieldValue(field)"
                  [required]="field.required"
                  [disabled]="isReadOnly"
                  (input)="onFieldChange(field, $any($event.target).value)"
                />
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Textarea -->
              <ng-container *ngSwitchCase="'textarea'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <textarea
                  [id]="'field_' + field.id"
                  class="form-control textarea"
                  [placeholder]="field.placeholder || ''"
                  [value]="getFieldValue(field)"
                  [required]="field.required"
                  [disabled]="isReadOnly"
                  (input)="onFieldChange(field, $any($event.target).value)"
                ></textarea>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Select Dropdown -->
              <ng-container *ngSwitchCase="'select'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <select
                  [id]="'field_' + field.id"
                  class="form-control"
                  [ngModel]="getFieldValue(field)"
                  [required]="!!field?.required"
                  [disabled]="isReadOnly"
                  (ngModelChange)="onFieldChange(field, $event)"
                >
                  <option value="">
                    {{ field.placeholder || "Select an option" }}
                  </option>
                  <option
                    *ngFor="let option of field.options"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Select Search -->
              <ng-container *ngSwitchCase="'select-search'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <div class="select-search-container">
                  <mat-icon class="select-search-icon">search</mat-icon>
                  <input
                    [id]="'field_' + field.id"
                    type="text"
                    class="form-control select-search-input"
                    [class.dropdown-open]="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                    placeholder="Type to search..."
                    [value]="getSelectSearchQuery(field)"
                    [required]="field.required"
                    [disabled]="isReadOnly"
                    (input)="
                      onSelectSearchInput(field, $any($event.target).value)
                    "
                    (focus)="onSelectSearchFocus(field)"
                    (blur)="onSelectSearchBlur(field)"
                  />
                  <button
                    *ngIf="isSelectSearchSingleMode(field) && getSelectSearchSelectedValues(field).length > 0 && !isReadOnly"
                    type="button"
                    class="select-search-clear"
                    (click)="clearSelectSearchSingleValue(field)"
                  >✕</button>
                  <div
                    *ngIf="
                      isSelectSearchDropdownOpen(field) &&
                      getSelectSearchOptions(field).length > 0
                    "
                    class="select-search-dropdown"
                  >
                    <div
                      *ngFor="let option of getSelectSearchOptions(field)"
                      class="select-search-option"
                      [class.selected]="
                        isSelectSearchOptionSelected(field, option)
                      "
                      (click)="onSelectSearchOptionClick(field, option)"
                    >
                      {{ option.label }}
                    </div>
                  </div>
                  <div
                    *ngIf="isSelectSearchLoading(field)"
                    class="select-search-loading"
                  >
                    Searching...
                  </div>
                  <div
                    *ngIf="
                      isSelectSearchDropdownOpen(field) &&
                      getSelectSearchOptions(field).length === 0 &&
                      !isSelectSearchLoading(field) &&
                      getSelectSearchQuery(field).length >= 2
                    "
                    class="select-search-no-results"
                  >
                    No results found
                  </div>
                </div>

                <!-- Selected Values Display (multi-select only) -->
                <div
                  *ngIf="getSelectSearchSelectedValues(field).length > 0 && !isSelectSearchSingleMode(field)"
                  class="selected-values-container"
                >
                  <div class="selected-values-list">
                    <div
                      *ngFor="
                        let selectedValue of getSelectSearchSelectedValues(
                          field
                        )
                      "
                      class="selected-value-tag"
                    >
                      <span class="tag-text">{{ selectedValue.label }}</span>
                      <button
                        *ngIf="!isReadOnly"
                        type="button"
                        class="tag-remove"
                        (click)="removeSelectSearchValue(field, selectedValue)"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </div>

                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Third-Party Provider Search -->
              <ng-container *ngSwitchCase="'third-party-search'">
                <label [for]="'field_' + field.id">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator">*</span>
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <div class="select-search-container">
                  <mat-icon class="select-search-icon">search</mat-icon>
                  <input
                    [id]="'field_' + field.id"
                    type="text"
                    class="form-control select-search-input"
                    [class.dropdown-open]="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                    placeholder="Type at least 2 characters to search..."
                    [value]="getSelectSearchQuery(field)"
                    [required]="field.required"
                    [disabled]="isReadOnly"
                    (input)="onSelectSearchInput(field, $any($event.target).value)"
                    (focus)="onSelectSearchFocus(field)"
                    (blur)="onSelectSearchBlur(field)"
                  />
                  <div
                    *ngIf="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                    class="select-search-dropdown"
                  >
                    <div
                      *ngFor="let option of getSelectSearchOptions(field)"
                      class="select-search-option"
                      [class.selected]="isSelectSearchOptionSelected(field, option)"
                      (click)="onSelectSearchOptionClick(field, option)"
                    >
                      {{ option.label }}
                    </div>
                  </div>
                  <div *ngIf="isSelectSearchLoading(field)" class="select-search-loading">
                    Searching...
                  </div>
                  <div
                    *ngIf="
                      isSelectSearchDropdownOpen(field) &&
                      getSelectSearchOptions(field).length === 0 &&
                      !isSelectSearchLoading(field) &&
                      getSelectSearchQuery(field).length >= 2
                    "
                    class="select-search-no-results"
                  >
                    No results found
                  </div>
                </div>
                <!-- Selected tags -->
                <div
                  *ngIf="getSelectSearchSelectedValues(field).length > 0"
                  class="selected-values-container"
                >
                  <div class="selected-values-list">
                    <div
                      *ngFor="let selectedValue of getSelectSearchSelectedValues(field)"
                      class="selected-value-tag"
                    >
                      <span class="tag-text">{{ selectedValue.label }}</span>
                      <button
                        *ngIf="!isReadOnly"
                        type="button"
                        class="tag-remove"
                        (click)="removeSelectSearchValue(field, selectedValue)"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </div>
                <small *ngIf="field.required" class="required-text">This field is mandatory</small>
              </ng-container>

              <!-- Radio Buttons -->
              <ng-container *ngSwitchCase="'radio'">
                <label class="section-label">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                    style="background-color: red"
                  ></div>
                </div>
                <div class="radio-group">
                  <label
                    *ngFor="let option of field.options"
                    class="radio-item"
                  >
                    <input
                      type="radio"
                      [name]="'field_' + field.id"
                      [value]="option.value"
                      [checked]="getFieldValue(field) === option.value"
                      [required]="field.required"
                      [disabled]="isReadOnly"
                      (change)="onFieldChange(field, option.value)"
                    />
                    {{ option.label }}
                  </label>
                </div>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Checkboxes -->
              <ng-container *ngSwitchCase="'checkbox'">
                <label class="section-label">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <div class="checkbox-group">
                  <label
                    *ngFor="let option of field.options"
                    class="checkbox-item"
                  >
                    <input
                      type="checkbox"
                      [name]="'field_' + field.id"
                      [value]="option.value"
                      [checked]="isCheckboxChecked(field, option.value)"
                      [required]="field.required"
                      [disabled]="isReadOnly"
                      (change)="onFieldChange(field, option.value)"
                    />
                    {{ option.label }}
                  </label>
                </div>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Dropdown -->
              <ng-container *ngSwitchCase="'dropdown'">
                <label class="section-label">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <!-- Country filter radio buttons (only for fields with otherOptions) -->
                <div *ngIf="field.otherOptions?.length" class="radio-group">
                    <label class="radio-item">
                    <input
                      type="radio"
                      [name]="'country_mode_' + field.id"
                      value="legal-entities"
                      [checked]="getCountryFilterMode(field) === 'legal-entities'"
                      [disabled]="isReadOnly"
                      (change)="onCountryFilterModeChange(field, 'legal-entities')"
                    />
                    Operating Countries
                  </label>
                  <label class="radio-item">
                    <input
                      type="radio"
                      [name]="'country_mode_' + field.id"
                      value="other"
                      [checked]="getCountryFilterMode(field) === 'other'"
                      [disabled]="isReadOnly"
                      (change)="onCountryFilterModeChange(field, 'other')"
                    />
                    Other
                  </label>
                </div>
                <div class="custom-dropdown-container" *ngIf="!field.otherOptions?.length || getCountryFilterMode(field) !== null">
                  <div
                    class="dropdown-display"
                    [class.readonly]="isReadOnly"
                    (click)="!isReadOnly && toggleDropdown('field_' + field.id)"
                  >
                    <span class="dropdown-text">{{
                      getDropdownDisplayText(field)
                    }}</span>
                    <span class="dropdown-arrow">▼</span>
                  </div>
                  <div
                    class="dropdown-menu"
                    [ngClass]="{ open: isDropdownOpen('field_' + field.id) }"
                  >
                    <div class="dropdown-search">
                      <input
                        type="text"
                        [disabled]="isReadOnly"
                        placeholder="Search..."
                        class="search-input"
                        [value]="getSearchTerm('field_' + field.id)"
                        (input)="
                          onSearchTermChange(
                            'field_' + field.id,
                            $any($event.target).value
                          )
                        "
                      />
                      <span class="search-icon">🔍</span>
                    </div>
                    <div class="dropdown-options">
                      <!-- Select All Option -->
                      <label
                        *ngIf="field.id === 5 || field.modelProperty === 'regions_activity' || field.modelProperty === 'individuals_location'"
                        class="dropdown-option select-all-option"
                      >
                        <input
                          type="checkbox"
                          [checked]="areAllOptionsSelected(field)"
                          (click)="toggleAllOptions(field); $event.stopPropagation()"
                        />
                        <span class="option-label"><strong>Select All</strong></span>
                      </label>
                      <div 
                        *ngIf="field.id === 5 || field.modelProperty === 'regions_activity' || field.modelProperty === 'individuals_location'"
                        class="dropdown-divider"
                      ></div>
                      <label
                        *ngFor="
                          let option of getFilteredOptions(
                            field,
                            'field_' + field.id
                          )
                        "
                        class="dropdown-option"
                      >
                        <input
                          type="checkbox"
                          [checked]="isCheckboxChecked(field, option.value)"
                          (click)="
                            onDropdownCheckboxClick($event, field, option.value)
                          "
                        />
                        <span class="option-label">{{ option.label }}</span>
                      </label>
                      <div
                        *ngIf="getFilteredOptions(field, 'field_' + field.id).length === 0"
                        class="no-options"
                      >
                        - EMPTY -
                      </div>
                    </div>
                    <div class="dropdown-footer">
                      <button
                        type="button"
                        class="reset-btn"
                        (click)="resetDropdownFilter(field)"
                      >
                        Reset filter
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Selected Options Display -->
                <div
                  class="selected-options-container"
                  *ngIf="getSelectedOptions(field).length > 0"
                >
                  <div
                    class="selected-option-tag"
                    *ngFor="let selectedOption of getSelectedOptions(field)"
                  >
                    <span class="tag-text">{{ selectedOption.label }}</span>
                    <button
                      type="button"
                      class="tag-remove"
                      [disabled]="isReadOnly"
                      (click)="
                        removeSelectedOption(field, selectedOption.value)
                      "
                    >
                      ✕
                    </button>
                  </div>
                </div>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>

              <!-- Upload -->
              <ng-container *ngSwitchCase="'upload'">
                <label class="section-label">
                  {{ field.label }}
                  <span *ngIf="field.required" class="required-indicator"
                    >*</span
                  >
                  <mat-icon
                    *ngIf="field.tooltip"
                    class="tooltip-icon"
                    [appHtmlTooltip]="field.tooltip || ''"
                    >help</mat-icon
                  >
                </label>
                <div *ngIf="field.description" class="field-description">
                  <span *ngIf="!isHtmlDescription(field.description)">{{
                    field.description
                  }}</span>
                  <div
                    *ngIf="isHtmlDescription(field.description)"
                    [innerHTML]="field.description"
                  ></div>
                </div>
                <div class="upload-container">
                  <div
                    class="upload-area"
                    [ngClass]="{
                      'drag-over': isDragOver('field_' + field.id),
                      readonly: isReadOnly
                    }"
                    (dragover)="
                      !isReadOnly && onDragOver($event, 'field_' + field.id)
                    "
                    (dragleave)="
                      !isReadOnly && onDragLeave($event, 'field_' + field.id)
                    "
                    (drop)="!isReadOnly && onDrop($event, field)"
                  >
                    <input
                      type="file"
                      [id]="'field_' + field.id"
                      class="file-input"
                      multiple
                      [disabled]="isReadOnly"
                      (change)="onFileSelected($event, field)"
                      #fileInput
                    />
                    <div class="upload-content">
                      <div class="upload-icon">📄</div>
                      <div class="upload-text">
                        <p class="upload-main-text">
                          Drop files here or
                          <button
                            type="button"
                            class="upload-link"
                            (click)="fileInput.click()"
                          >
                            browse
                          </button>
                        </p>
                        <p class="upload-sub-text">
                          Supports: PDF, DOC, DOCX, JPG, PNG (Max 10MB)
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Uploaded Files Display -->
                  <div
                    class="uploaded-files"
                    *ngIf="getAllFilesForField(field).length > 0"
                  >
                    <div
                      class="uploaded-file"
                      [class.uploading]="isFileUploading(file)"
                      *ngFor="
                        let file of getAllFilesForField(field);
                        let i = index
                      "
                    >
                      <div class="file-info">
                        <span class="file-icon" *ngIf="!isFileUploading(file)">📎</span>
                        <span class="file-icon uploading-spinner" *ngIf="isFileUploading(file)">
                          <span class="spinner"></span>
                        </span>
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{
                          formatFileSize(file.size)
                        }}</span>
                        <span class="uploading-text" *ngIf="isFileUploading(file)">Uploading...</span>
                      </div>
                      <div class="file-actions" *ngIf="!isFileUploading(file)">
                        <button
                          type="button"
                          class="file-download"
                          (click)="downloadUploadedFile(file)"
                          title="Download file"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          *ngIf="!isReadOnly"
                          type="button"
                          class="file-remove"
                          (click)="removeUploadedFile(field, i)"
                          title="Remove file"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <small *ngIf="field.required" class="required-text"
                  >This field is mandatory</small
                >
              </ng-container>
            </ng-container>
          </div>
        </div>

        <!-- Handle subgroups -->
        <div
          *ngIf="questionGroup.subgroups.length > 0"
          class="subgroups-container"
        >
          <div
            *ngFor="let subgroup of questionGroup.subgroups"
            class="form-subsection"
            [ngClass]="'level-' + subgroup.level"
          >
            <h4 *ngIf="subgroup.title" class="subsection-title">
              {{ subgroup.title }}
            </h4>

            <div
              *ngFor="let field of subgroup.fields"
              class="form-group"
              [ngClass]="'field-' + field.type"
            >
              <ng-container [ngSwitch]="field.type">
                <!-- Text Input -->
                <ng-container *ngSwitchCase="'text'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <span *ngIf="field.required" class="required-indicator"
                      >*</span
                    >
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <input
                    [id]="'field_' + field.id"
                    type="text"
                    class="form-control"
                    [placeholder]="field.placeholder || ''"
                    [value]="getFieldValue(field)"
                    [required]="field.required"
                    [disabled]="isReadOnly"
                    (input)="onFieldChange(field, $any($event.target).value)"
                  />
                  <small *ngIf="field.required" class="required-text"
                    >This field is mandatory</small
                  >
                </ng-container>

                <!-- Email Input -->
                <ng-container *ngSwitchCase="'email'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <span *ngIf="field.required" class="required-indicator"
                      >*</span
                    >
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <input
                    [id]="'field_' + field.id"
                    type="email"
                    class="form-control"
                    [placeholder]="field.placeholder || ''"
                    [value]="getFieldValue(field)"
                    [required]="field.required"
                    [disabled]="isReadOnly"
                    (input)="onFieldChange(field, $any($event.target).value)"
                  />
                  <small *ngIf="field.required" class="required-text"
                    >This field is mandatory</small
                  >
                </ng-container>

                <!-- Textarea -->
                <ng-container *ngSwitchCase="'textarea'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <textarea
                    [id]="'field_' + field.id"
                    class="form-control textarea"
                    [placeholder]="field.placeholder || ''"
                    [value]="getFieldValue(field)"
                    [disabled]="isReadOnly"
                    (input)="onFieldChange(field, $any($event.target).value)"
                  ></textarea>
                </ng-container>

                <!-- Select Dropdown -->
                <ng-container *ngSwitchCase="'select'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <select
                    [id]="'field_' + field.id"
                    class="form-control"
                    [ngModel]="getFieldValue(field)"
                    [disabled]="isReadOnly"
                    (ngModelChange)="onFieldChange(field, $event)"
                  >
                    <option value="">
                      {{ field.placeholder || "Select an option" }}
                    </option>
                    <option
                      *ngFor="let option of field.options"
                      [value]="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </ng-container>

                <!-- Select Search -->
                <ng-container *ngSwitchCase="'select-search'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <span *ngIf="field.required" class="required-indicator"
                      >*</span
                    >
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <div class="select-search-container">
                    <mat-icon class="select-search-icon">search</mat-icon>
                    <input
                      [id]="'field_' + field.id"
                      type="text"
                      class="form-control select-search-input"
                      [class.dropdown-open]="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                      placeholder="Type to search..."
                      [value]="getSelectSearchQuery(field)"
                      [required]="field.required"
                      [disabled]="isReadOnly"
                      (input)="
                        onSelectSearchInput(field, $any($event.target).value)
                      "
                      (focus)="onSelectSearchFocus(field)"
                      (blur)="onSelectSearchBlur(field)"
                    />
                    <button
                      *ngIf="isSelectSearchSingleMode(field) && getSelectSearchSelectedValues(field).length > 0 && !isReadOnly"
                      type="button"
                      class="select-search-clear"
                      (click)="clearSelectSearchSingleValue(field)"
                    >✕</button>
                    <div
                      *ngIf="
                        isSelectSearchDropdownOpen(field) &&
                        getSelectSearchOptions(field).length > 0
                      "
                      class="select-search-dropdown"
                    >
                      <div
                        *ngFor="let option of getSelectSearchOptions(field)"
                        class="select-search-option"
                        [class.selected]="
                          isSelectSearchOptionSelected(field, option)
                        "
                        (click)="onSelectSearchOptionClick(field, option)"
                      >
                        {{ option.label }}
                      </div>
                    </div>
                    <div
                      *ngIf="isSelectSearchLoading(field)"
                      class="select-search-loading"
                    >
                      Searching...
                    </div>
                    <div
                      *ngIf="
                        isSelectSearchDropdownOpen(field) &&
                        getSelectSearchOptions(field).length === 0 &&
                        !isSelectSearchLoading(field) &&
                        getSelectSearchQuery(field).length >= 2
                      "
                      class="select-search-no-results"
                    >
                      No results found
                    </div>
                  </div>

                  <!-- Selected Values Display (multi-select only) -->
                  <div
                    *ngIf="getSelectSearchSelectedValues(field).length > 0 && !isSelectSearchSingleMode(field)"
                    class="selected-values-container"
                  >
                    <div class="selected-values-list">
                      <div
                        *ngFor="
                          let selectedValue of getSelectSearchSelectedValues(
                            field
                          )
                        "
                        class="selected-value-tag"
                      >
                        <span class="tag-text">{{ selectedValue.label }}</span>
                        <button
                          *ngIf="!isReadOnly"
                          type="button"
                          class="tag-remove"
                          (click)="
                            removeSelectSearchValue(field, selectedValue)
                          "
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  </div>

                  <small *ngIf="field.required" class="required-text"
                    >This field is mandatory</small
                  >
                </ng-container>

                <!-- Third-Party Provider Search -->
                <ng-container *ngSwitchCase="'third-party-search'">
                  <label [for]="'field_' + field.id">
                    {{ field.label }}
                    <span *ngIf="field.required" class="required-indicator">*</span>
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <div class="select-search-container">
                    <mat-icon class="select-search-icon">search</mat-icon>
                    <input
                      [id]="'field_' + field.id"
                      type="text"
                      class="form-control select-search-input"
                      [class.dropdown-open]="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                      placeholder="Type at least 2 characters to search..."
                      [value]="getSelectSearchQuery(field)"
                      [required]="field.required"
                      [disabled]="isReadOnly"
                      (input)="onSelectSearchInput(field, $any($event.target).value)"
                      (focus)="onSelectSearchFocus(field)"
                      (blur)="onSelectSearchBlur(field)"
                    />
                    <div
                      *ngIf="isSelectSearchDropdownOpen(field) && getSelectSearchOptions(field).length > 0"
                      class="select-search-dropdown"
                    >
                      <div
                        *ngFor="let option of getSelectSearchOptions(field)"
                        class="select-search-option"
                        [class.selected]="isSelectSearchOptionSelected(field, option)"
                        (click)="onSelectSearchOptionClick(field, option)"
                      >
                        {{ option.label }}
                      </div>
                    </div>
                    <div *ngIf="isSelectSearchLoading(field)" class="select-search-loading">
                      Searching...
                    </div>
                    <div
                      *ngIf="
                        isSelectSearchDropdownOpen(field) &&
                        getSelectSearchOptions(field).length === 0 &&
                        !isSelectSearchLoading(field) &&
                        getSelectSearchQuery(field).length >= 2
                      "
                      class="select-search-no-results"
                    >
                      No results found
                    </div>
                  </div>
                  <!-- Selected tags -->
                  <div
                    *ngIf="getSelectSearchSelectedValues(field).length > 0"
                    class="selected-values-container"
                  >
                    <div class="selected-values-list">
                      <div
                        *ngFor="let selectedValue of getSelectSearchSelectedValues(field)"
                        class="selected-value-tag"
                      >
                        <span class="tag-text">{{ selectedValue.label }}</span>
                        <button
                          *ngIf="!isReadOnly"
                          type="button"
                          class="tag-remove"
                          (click)="removeSelectSearchValue(field, selectedValue)"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  </div>
                  <small *ngIf="field.required" class="required-text">This field is mandatory</small>
                </ng-container>

                <!-- Radio Buttons -->
                <ng-container *ngSwitchCase="'radio'">
                  <label class="section-label">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <div class="radio-group">
                    <label
                      *ngFor="let option of field.options"
                      class="radio-item"
                    >
                      <input
                        type="radio"
                        [name]="'field_' + field.id"
                        [value]="option.value"
                        [checked]="getFieldValue(field) === option.value"
                        [disabled]="isReadOnly"
                        (change)="onFieldChange(field, option.value)"
                      />
                      {{ option.label }}
                    </label>
                  </div>
                </ng-container>

                <!-- Checkboxes -->
                <ng-container *ngSwitchCase="'checkbox'">
                  <label class="section-label">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <div class="checkbox-group">
                    <label
                      *ngFor="let option of field.options"
                      class="checkbox-item"
                    >
                      <input
                        type="checkbox"
                        [name]="'field_' + field.id"
                        [value]="option.value"
                        [checked]="isCheckboxChecked(field, option.value)"
                        [disabled]="isReadOnly"
                        (change)="onFieldChange(field, option.value)"
                      />
                      {{ option.label }}
                    </label>
                  </div>
                </ng-container>

                <!-- Dropdown -->
                <ng-container *ngSwitchCase="'dropdown'">
                  <label class="section-label">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <!-- Removed limitation notice for 25 selections -->
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <!-- Country filter radio buttons (only for fields with otherOptions) -->
                  <div *ngIf="field.otherOptions?.length" class="radio-group">
                    <label class="radio-item">
                      <input
                        type="radio"
                        [name]="'country_mode_' + field.id"
                        value="legal-entities"
                        [checked]="getCountryFilterMode(field) === 'legal-entities'"
                        [disabled]="isReadOnly"
                        (change)="onCountryFilterModeChange(field, 'legal-entities')"
                      />
                      Operating Countries
                    </label>
                    <label class="radio-item">
                      <input
                        type="radio"
                        [name]="'country_mode_' + field.id"
                        value="other"
                        [checked]="getCountryFilterMode(field) === 'other'"
                        [disabled]="isReadOnly"
                        (change)="onCountryFilterModeChange(field, 'other')"
                      />
                      Other
                    </label>
                  </div>
                  <div class="custom-dropdown-container" *ngIf="!field.otherOptions?.length || getCountryFilterMode(field) !== null">
                    <div
                      class="dropdown-display"
                      (click)="
                        !isReadOnly && toggleDropdown('field_' + field.id)
                      "
                      [class.readonly]="isReadOnly"
                    >
                      <span class="dropdown-text">{{
                        getDropdownDisplayText(field)
                      }}</span>
                      <span class="dropdown-arrow">▼</span>
                    </div>
                    <div
                      class="dropdown-menu"
                      [ngClass]="{ open: isDropdownOpen('field_' + field.id) }"
                    >
                      <div class="dropdown-search">
                        <input
                          [disabled]="isReadOnly"
                          type="text"
                          placeholder="Search..."
                          class="search-input"
                          [disabled]="isReadOnly"
                          [value]="getSearchTerm('field_' + field.id)"
                          (input)="
                            onSearchTermChange(
                              'field_' + field.id,
                              $any($event.target).value
                            )
                          "
                        />
                        <span class="search-icon">🔍</span>
                      </div>
                      <div class="dropdown-options">
                        <!-- Select All Option -->
                        <label
                          *ngIf="field.id === 5 || field.modelProperty === 'regions_activity' || field.modelProperty === 'individuals_location'"
                          class="dropdown-option select-all-option"
                        >
                          <input
                            type="checkbox"
                            [checked]="areAllOptionsSelected(field)"
                            [disabled]="isReadOnly"
                            (click)="toggleAllOptions(field); $event.stopPropagation()"
                          />
                          <span class="option-label"><strong>Select All</strong></span>
                        </label>
                        <div 
                          *ngIf="field.id === 5 || field.modelProperty === 'regions_activity' || field.modelProperty === 'individuals_location'"
                          class="dropdown-divider"
                        ></div>
                        <label
                          *ngFor="
                            let option of getFilteredOptions(
                              field,
                              'field_' + field.id
                            )
                          "
                          class="dropdown-option"
                        >
                          <input
                            type="checkbox"
                            [checked]="isCheckboxChecked(field, option.value)"
                            [disabled]="isReadOnly"
                            (click)="
                              onDropdownCheckboxClick(
                                $event,
                                field,
                                option.value
                              )
                            "
                          />
                          <span class="option-label">{{ option.label }}</span>
                        </label>
                        <div
                          *ngIf="getFilteredOptions(field, 'field_' + field.id).length === 0"
                          class="no-options"
                        >
                          - EMPTY -
                        </div>
                      </div>
                      <div class="dropdown-footer">
                        <button
                          type="button"
                          class="reset-btn"
                          [disabled]="isReadOnly"
                          (click)="resetDropdownFilter(field)"
                        >
                          Reset filter
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Selected Options Display -->
                  <div
                    class="selected-options-container"
                    *ngIf="getSelectedOptions(field).length > 0"
                  >
                    <div
                      class="selected-option-tag"
                      *ngFor="let selectedOption of getSelectedOptions(field)"
                    >
                      <span class="tag-text">{{ selectedOption.label }}</span>
                      <button
                        type="button"
                        class="tag-remove"
                        [disabled]="isReadOnly"
                        *ngIf="!isReadOnly"
                        (click)="
                          removeSelectedOption(field, selectedOption.value)
                        "
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </ng-container>

                <!-- Upload -->
                <ng-container *ngSwitchCase="'upload'">
                  <label class="section-label">
                    {{ field.label }}
                    <mat-icon
                      *ngIf="field.tooltip"
                      class="tooltip-icon"
                      [appHtmlTooltip]="field.tooltip || ''"
                      >help</mat-icon
                    >
                  </label>
                  <div *ngIf="field.description" class="field-description">
                    <span *ngIf="!isHtmlDescription(field.description)">{{
                      field.description
                    }}</span>
                    <div
                      *ngIf="isHtmlDescription(field.description)"
                      [innerHTML]="field.description"
                    ></div>
                  </div>
                  <div class="upload-container">
                    <div
                      class="upload-area"
                      [ngClass]="{
                        'drag-over': isDragOver('field_' + field.id),
                        readonly: isReadOnly
                      }"
                      (dragover)="
                        !isReadOnly && onDragOver($event, 'field_' + field.id)
                      "
                      (dragleave)="
                        !isReadOnly && onDragLeave($event, 'field_' + field.id)
                      "
                      (drop)="!isReadOnly && onDrop($event, field)"
                    >
                      <input
                        type="file"
                        [id]="'field_' + field.id"
                        class="file-input"
                        multiple
                        [disabled]="isReadOnly"
                        (change)="onFileSelected($event, field)"
                        #fileInput
                      />
                      <div class="upload-content">
                        <div class="upload-icon">📄</div>
                        <div class="upload-text">
                          <p class="upload-main-text">
                            Drop files here or
                            <button
                              type="button"
                              class="upload-link"
                              [disabled]="isReadOnly"
                              (click)="fileInput.click()"
                            >
                              browse
                            </button>
                          </p>
                          <p class="upload-sub-text">
                            Supports: PDF, DOC, DOCX, JPG, PNG (Max 10MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- Uploaded Files Display -->
                    <div
                      class="uploaded-files"
                      *ngIf="getAllFilesForField(field).length > 0"
                    >
                      <div
                        class="uploaded-file"
                        [class.uploading]="isFileUploading(file)"
                        *ngFor="
                          let file of getAllFilesForField(field);
                          let i = index
                        "
                      >
                        <div class="file-info">
                          <span class="file-icon" *ngIf="!isFileUploading(file)">📎</span>
                          <span class="file-icon uploading-spinner" *ngIf="isFileUploading(file)">
                            <span class="spinner"></span>
                          </span>
                          <span class="file-name">{{ file.name }}</span>
                          <span class="file-size">{{
                            formatFileSize(file.size)
                          }}</span>
                          <span class="uploading-text" *ngIf="isFileUploading(file)">Uploading...</span>
                        </div>
                        <div class="file-actions" *ngIf="!isFileUploading(file)">
                        <button
                          type="button"
                          class="file-download"
                          (click)="downloadUploadedFile(file)"
                          title="Download file"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          *ngIf="!isReadOnly"
                          type="button"
                          class="file-remove"
                          (click)="removeUploadedFile(field, i)"
                          title="Remove file"
                        >
                          ✕
                        </button>
                      </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Placeholder for other steps -->
    <div
      *ngIf="currentStep > 1 && !getCurrentStepData() && !isLoading && !error"
      class="step-content"
    >
      <h2 class="step-heading">{{ steps[currentStep - 1].title }}</h2>
      <p class="placeholder-text">
        Content for step {{ currentStep }} will be implemented here.
      </p>
    </div>
  </div>

  <!-- Buttons for editing mode: Back to Dashboard, Previous, Next, Update -->
  <div
    class="form-actions"
    *ngIf="
      !isLoading &&
      !error &&
      !showSubmissionConfirmation &&
      uiMode === 'editing'
    "
  >
    <div class="left-buttons">
      <button
        type="button"
        class="btn btn-back"
        (click)="router.navigate(['/dashboard'])"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-save"
        (click)="onSaveForLater()"
        *ngIf="this.ropaVersion"
      >
        Save for later
      </button>
    </div>

    <div class="right-buttons">
      <button
        type="button"
        class="btn btn-back"
        (click)="previousStep()"
        *ngIf="currentStep > 1"
      >
        Previous
      </button>

      <button
        type="button"
        class="btn btn-continue"
        (click)="nextStep()"
        *ngIf="currentStep < ropaForm.steps.length"
      >
        Next
      </button>

      <!-- For drafts: Show "Save Changes" button -->
      <button
        type="button"
        class="btn btn-continue"
        (click)="updateDraft()"
        [disabled]="isReadOnly || !hasFormChanges"
        *ngIf="!ropaVersion"
      >
        Save Changes
      </button>

      <!-- For projects: Show "Update" button -->
      <button
        type="button"
        class="btn btn-continue"
        (click)="onNext()"
        [disabled]="isReadOnly || !dynamicFormGroup.valid"
        *ngIf="currentStep === ropaForm.steps.length && ropaVersion"
      >
        Update
      </button>
    </div>
  </div>

  <!-- Buttons for readonly mode: Back to Dashboard, Previous, Next -->
  <div
    class="form-actions"
    *ngIf="
      !isLoading &&
      !error &&
      !showSubmissionConfirmation &&
      uiMode === 'readonly'
    "
  >
    <button
      type="button"
      class="btn btn-back"
      (click)="router.navigate(['/dashboard'])"
    >
      Back to Dashboard
    </button>

    <div class="right-buttons">
      <button
        type="button"
        class="btn btn-back"
        (click)="previousStep()"
        *ngIf="currentStep > 1"
      >
        Previous
      </button>

      <button
        type="button"
        class="btn btn-continue"
        (click)="nextStep()"
        *ngIf="currentStep < ropaForm.steps.length"
      >
        Next
      </button>
    </div>
  </div>

  <!-- Buttons for new mode: Cancel, Previous, Next, Done -->
  <div
    class="form-actions"
    *ngIf="
      !isLoading && !error && !showSubmissionConfirmation && uiMode === 'new'
    "
  >
    <!-- Cancel button - always on the left -->
    <div class="left-buttons">
      <button type="button" class="btn btn-back" (click)="onCancel()">
        Cancel
      </button>
      <button type="button" class="btn btn-save" (click)="onSaveForLater()">
        Save for later
      </button>
    </div>

    <div class="right-buttons">
      <button
        type="button"
        class="btn btn-back"
        (click)="previousStep()"
        *ngIf="currentStep > 1"
      >
        Previous
      </button>

      <button
        type="button"
        class="btn btn-continue"
        (click)="onNext()"
        *ngIf="currentStep < ropaForm.steps.length"
      >
        <!-- [disabled]="!isCurrentStepValid()" -->
        Next
      </button>

      <button
        type="button"
        class="btn btn-continue"
        (click)="onNext()"
        [disabled]="!dynamicFormGroup.valid"
        *ngIf="currentStep === ropaForm.steps.length"
      >
        Done
      </button>
    </div>
  </div>
</div>

<app-status-change-modal
  [isOpen]="showSaveForLaterResultModal"
  [state]="saveForLaterResultState"
  title="Save for Later"
  successMessage="Your draft has been saved successfully. You can continue editing it from your dashboard."
  [errorMessage]="'Your draft could not be saved at this time. Please try again. If the problem continues, contact your system administrator.'"
  (close)="onSaveForLaterResultModalClose()"
></app-status-change-modal>
<app-footer></app-footer>
